import { useCallback, useEffect, useRef } from 'react';
import { useSearchParams } from 'views/Multitab/Router';

/** App-owned tab names in navigation links; only currently available tabs can be selected. */
export function useAgentPageTab<T extends string>(
  change: (tab: T) => void,
  available: readonly T[],
  parameter = 'agentTab',
) {
  const [params, setParams] = useSearchParams();
  const requested = params.get(parameter);
  const selected = available.includes(requested as T) ? (requested as T) : undefined;
  const changeRef = useRef(change);
  changeRef.current = change;
  useEffect(() => {
    if (selected) changeRef.current(selected);
  }, [selected]);
  return useCallback(
    (tab: T) => {
      changeRef.current(tab);
      if (params.has(parameter)) {
        const next = new URLSearchParams(params);
        next.delete(parameter);
        if (parameter === 'agentView') next.delete('agentTab');
        setParams(next, { replace: true });
      }
    },
    [params, parameter, setParams],
  );
}
